<template>
  <div class="container-fluid grayed-offset">
    <div class="container-fixed">
      <VMessage v-if="message" :type="message.type" v-bind="message" closable class="offset-top-1" @close="message = null" />
    </div>

    <VTest :default-test="defaultTest" :test-diffs="testDiffs" i18n="substore">
      <template #tests="{ items }">
        <VGrid :items="items" :has-any-promo="true">
          <template #label>
            Examples
          </template>
          <template #item="{ item }">
            <VStockProductItem v-bind="item" :texts="{ ...item.texts, productName: item.description }" @message="onMessage" />
          </template>
        </VGrid>
      </template>
    </VTest>
  </div>
</template>

<script>
import VTest from '@/components/Test';

import VGrid from '@/components/Substore/StockGrid';
import VStockProductItem from '@/components/Substore/StockProduct/Item';
import defaultTest from './default';
import testDiffs from './diffs';

export default {
  name: 'StockproductTest',

  components: {
    VGrid,
    VTest,
    VStockProductItem,
    VMessage: () => import('@/components/Message'),
  },

  data() {
    return {
      defaultTest,
      testDiffs,
      message: null,
    };
  },

  methods: {
    onMessage(message) {
      this.message = message;
    },
  },
};
</script>
